import styled from "styled-components";

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.1rem;
`;

export const FormInputLabel = styled.label`
  font-family: "poppins-medium", sans-serif;
  font-size: 0.82rem;
  letter-spacing: 0.02rem;
  color: var(--text-muted);
`;

export const Input = styled.input`
  font-family: "poppins-regular", sans-serif;
  font-size: 0.95rem;
  color: var(--text);
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 0.8rem 1rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  transition: border-color 0.3s var(--ease), background 0.3s var(--ease),
    box-shadow 0.3s var(--ease);

  &::placeholder {
    color: var(--text-dim);
  }

  &:focus {
    outline: none;
    border-color: var(--accent);
    background: rgba(255, 255, 255, 0.06);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  &[type="password"] {
    letter-spacing: 0.15em;

    &::placeholder {
      letter-spacing: normal;
    }
  }
`;
